<template>
    <a class="button is-info" @click="submitForm" :class="{ 'is-loading' : isLoading }">
        Update
    </a>
</template>

<script>
    import apiPricePlans from './../../../../../api/apiPricePlans'
    export default {
        data () {
            return {
                isLoading: false
            }
        },
        methods: {
            submitForm() {
                let data = { id: this.$route.params.id, query: this.$store.getters.getNewPricePlan }
                apiPricePlans
                    .updatePricePlanRequest(data)
                    .then((response) => {
                        this.$router.push({path: '/plans'})
                    })
                    .catch((error) => {
                        console.log(error)
                    })

            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/ControlPanel/PricePlans/NewPlan/Inputs/UpdatePricePlan.vue